import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="container py-5">
      <div className="card bg-onyx border-0 shadow-lg">
        <div className="card-body py-5 text-center">
          <h1 className="text-white mb-3">404</h1>
          <p className="text-white-50 mb-4">A rota solicitada não existe neste ambiente.</p>
          <Link to="/" className="btn btn-brand">
            Voltar para a agenda
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
